import Div from "theme/layouts/Div";
import ProductPromotionBlock from "theme/libs/wordpress/content/cmsBlocks/ProductPromotionBlock";
import PropTypes from "prop-types";
import React from "react";

const ProductPromotion = ({ content, ...rest }) => {
    return (
        <Div
            as="section"
            display="grid"
            aspectRatio={[4 / 6, null, null, null, 16 / 9]}
            maxHeight="100vh"
            width="100%"
            my={["64px", null, null, null, "104px"]}
        >
            <ProductPromotionBlock isFullWidth content={content.data} {...rest} />
        </Div>
    );
};

ProductPromotion.propTypes = {
    content: PropTypes.object.isRequired,
};

export default ProductPromotion;
